var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserCoursePlaceholder = function SvgUserCoursePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 216,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6a6 6 0 0 1 6-6h242v216H6a6 6 0 0 1-6-6V6Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F0EF",
    d: "M0 0h248v216H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 81a3 3 0 0 1 3-3h18a15.001 15.001 0 0 1 15 15v42a3 3 0 1 1-6 0 6.003 6.003 0 0 0-1.757-4.243A6.003 6.003 0 0 0 115 129H94a3 3 0 0 1-3-3V81Zm30 43.608V93a9 9 0 0 0-9-9H97v39h18c2.125 0 4.191.563 6 1.608Z",
    fill: "#D7D3D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.393 82.393A15.001 15.001 0 0 1 136 78h18a3 3 0 0 1 3 3v45a3 3 0 0 1-3 3h-21a6.003 6.003 0 0 0-4.243 1.757A6.003 6.003 0 0 0 127 135a3 3 0 1 1-6 0V93a15 15 0 0 1 4.393-10.607ZM127 124.608a11.992 11.992 0 0 1 6-1.608h18V84h-15a9 9 0 0 0-9 9v31.608Z",
    fill: "#D7D3D1"
  })));
};
export { SvgUserCoursePlaceholder as ReactComponent };
export default __webpack_public_path__ + "edc9530eeb4c876366a9ed8095f777da.svg";